// extracted by mini-css-extract-plugin
export default {"w-full":"Products_w-full__WKNGK","products":"Products_products__s4T9C","head":"Products_head__-mQs9","title":"Products_title__5hh2t","wrapper":"Products_wrapper__gn7Ue"};